import React from 'react';
import LoginForm from './components/loginform';
import Dashboard from './components/dashboard';
import ItemList from './components/items/itemlist';
import ItemForm from './components/items/itemform';
import MenuList from './components/menus/menulist';
import MenuForm from './components/menus/menuform';
import CustomerList from './components/clients/clientlist';
import MenuImport from './components/menus/menuimport';
import ClientImport from './components/clients/clientimport';
import CustomerForm from './components/clients/clientform';
import OrderList from './components/orders/orderlist';
import OrderForm from './components/orders/orderform';
import RouteList from './components/routes/routelist';
import RouteForm from './components/routes/routeform';
// import InvoiceList from './components/invoices/invoicelist';
// import InvoiceForm from './components/invoices/invoiceform';
import ProviderList from './components/providers/providerlist';
import ProviderForm from './components/providers/providerform';
import Unauthorized from './components/common/unauthorized';
import ReportHome from './components/reports/reports';
import Help from './components/help/helppage';
import DeliveryList from './components/deliveries/deliverylist';
import DeliveryForm from './components/deliveries/deliveryform';
import UserForm from './components/users/userform';
import UserList from './components/users/userlist';
import RegistrationForm from './components/registration';
import AccountSettings from './components/account/accountsettings'

const routes = [
    { path: "/", element: LoginForm, protected: false },
    { path: "/dashboard", element: Dashboard, protected: true, allowedRoles: ["admin", "customer"] },
    { path: "/items", element: ItemList, protected: true, supportsSearch: true, pageTitle: "Item List", allowedRoles: ["admin"] },
    { path: "/items/create", element: ItemForm, protected: true, allowedRoles: ["admin"], supportsSearch: false },
    { path: "/items/:itemId", element: ItemForm, protected: true, allowedRoles: ["admin"], supportsSearch: false },    
    { path: "/menus", element: MenuList, protected: true, supportsSearch: true, pageTitle: "Menu List", allowedRoles: ["admin"] },
    { path: "/menus/create", element: MenuForm, protected: true, allowedRoles: ["admin"], supportsSearch: false },
    { path: "/menus/:menuId", element: MenuForm, protected: true, allowedRoles: ["admin"], supportsSearch: false },
    { path: "/menus/import", element: MenuImport, protected: true, allowedRoles: ["admin"], supportsSearch: false },
    { path: "/clients", element: CustomerList, protected: true, supportsSearch: true },
    { path: "/clients/import", element: ClientImport, protected: true, allowedRoles: ["admin"], supportsSearch: false },
    { path: "/clients/create", element: CustomerForm, protected: true, allowedRoles: ["admin"] },
    { path: "/clients/:customerId", element: CustomerForm, protected: true, allowedRoles: ["admin"] },
    { path: "/users", element: UserList, protected: true, supportsSearch: true, pageTitle: "User List" },
    { path: "/users/create", element: UserForm, protected: true, supportsSearch: false, pageTitle: "User Form" },
    { path: "/users/:userId", element: UserForm, protected: true, supportsSearch: false, pageTitle: "User Form" },
    { path: "/providers", element: ProviderList, protected: true, supportsSearch: true, pageTitle: "Provider List" },
    { path: "/providers/create", element: ProviderForm, protected: true, allowedRoles: ["admin"] },
    { path: "/providers/:clientId", element: ProviderForm, protected: true, allowedRoles: ["admin"] },
    { path: "/orders", element: OrderList, protected: true, supportsSearch: true, allowedRoles: ["admin", "customer"] },
    { path: "/orders/create", element: OrderForm, protected: true, allowedRoles: ["admin", "customer"] },
    { path: "/orders/:orderId", element: OrderForm, protected: true, allowedRoles: ["admin", "customer"] },
    { path: "/deliveries", element: DeliveryList, protected: true, supportsSearch: true, pageTitle: "Delivery List" },
    { path: "/deliveries/create", element: DeliveryForm, protected: true, allowedRoles: ["admin"] },
    { path: "/deliveries/:deliveryId", element: DeliveryForm, protected: true, allowedRoles: ["admin"] },
    { path: "/routes", element: RouteList, protected: true, supportsSearch: true, pageTitle: "Route List" },
    { path: "/routes/create", element: RouteForm, protected: true, allowedRoles: ["admin"] },
    { path: "/routes/:routeId", element: RouteForm, protected: true, allowedRoles: ["admin"] },
    /*{ path: "/invoices", element: InvoiceList, protected: true, supportsSearch: true },
    { path: "/invoices/create", element: InvoiceForm, protected: true, allowedRoles: ["admin"] },
    { path: "/invoices/:invoiceId", element: InvoiceForm, protected: true, allowedRoles: ["admin"] },*/
    { path: "/reports", element: ReportHome, protected: true, allowedRoles: ["admin"] },
    { path: "/help", element: Help, protected: true, allowedRoles: ["admin", "customer"] },
    { path: "/login", element: LoginForm, protected: false },
    { path: "/logout", element: LoginForm, protected: false },
    { path: "/unauthorized", element: Unauthorized, protected: false },
    { path: "/register", element: RegistrationForm, protected: false },
    { path: "*", element: () => <h1>Not Found</h1>, protected: false },
    { path: "/account", element: AccountSettings, protected: true, supportsSearch: false, pageTitle: "Account Settings" }
];

export default routes;
